import { TaskService } from "../services/TaskService";

export const waitForExpectedResult = (
  serviceCall,
  isResultValid,
  callback,
  errorHandler,
  maxRetries = 10,
  timeout = 500
) => {
  let retry = 0;

  const myTimer = () => {
    retry++;
    serviceCall()
      .catch(() => {
        return null;
      })
      .then((result) => {
        if (!isResultValid(result)) {
          if (retry < maxRetries) {
            setTimeout(myTimer, timeout);
          } else {
            errorHandler();
          }
        } else if (callback) {
          callback(result);
        }
      });
  };

  setTimeout(myTimer, timeout);
};

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const awaitTask = async (taskId) => {
  let task = null;
  const now = new Date();
  while (task === null) {
    task = await TaskService.getTaskById(taskId);
    await sleep(2000);
    if (new Date() - now > 60000) {
      throw new Error("Task not found after 60 seconds");
    }
  }
  return task;
};
